// extracted by mini-css-extract-plugin
module.exports = {"reviewsGroup":"style_reviewsGroup__1k74B","review":"style_review__1q1Z8"};